// src/pages/Dashboard.jsx
import React from "react";
import { useAuth } from "../../utils/session/AuthContext";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header from "../../components/Header";
import FooterLanding from "../../components/FooterLanding";
import LandingCard from "../../components/LandingCard";
import flight_icon from '../../assets/images/logos/flights.svg';
import copa_ski from '../../assets/images/logos/general_logo.svg';
import rankin from '../../assets/images/logos/rankin.svg';
import epic from '../../assets/images/logos/epic.svg';
import main_image from '../../assets/images/logos/menu_image.png';
import experiencias from '../../assets/icons/info_evento_icons/exp_whis_icon.svg';
import resultados from '../../assets/icons/small_icons/resultados.svg';
import sos from '../../assets/icons/small_icons/sos.svg';
import whatsapp from '../../assets/icons/small_icons/whatsapp.svg';
import instagram from '../../assets/icons/small_icons/instagram.svg';
import aeromexico from '../../assets/icons/small_icons/AEROMEXICO.svg';
// import ski-vid from '../../assets/images/logos/ski-vid.mp4';
import links from '../../assets/icons/info_evento_icons/redes_icon.svg';
import WeatherWidget from "../../components/WeatherWidg";
import LandingButtons from "../../components/LandingButtons";

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/loginCopa");
  };

  return (
    <div className="vh-100 d-flex flex-column">
      <Header />

      {/* <div
        className="imgsection"
        style={{
          backgroundImage: `url(${main_image})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 20%",
          backgroundRepeat: "no-repeat",
          flex: 4,
        }}
      >
      </div> */}

    <div className="imgsection" style={{ position: "relative", flex: 3.5 }}>

      <video
        autoPlay
        loop
        muted
        playsInline
        poster={main_image}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          top: 0,
          left: 0,
        }}
      >
        <source src="/static/images/ski-vid.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Weather Widget Overlay */}
      <Link to="/weather" aria-label="Go to weather page">
      <div
        style={{
          position: "absolute",
          top: "15px",
          left: "15px",
          zIndex: 2,
          width: "260px"
        }}
      >
        <WeatherWidget />
      </div>
      </Link>

    </div>


      {/* landing cars section */}
      <div className="landingCards d-flex flex-column justify-content-evenly my-1" style={{ borderRadius: "12px", flex: 6.5}}>

        {/* first row */}
        <div className="row d-flex justify-content-evenly align-items-center m-0 p-0" style={{height: "39%"}}>
          <div className="col-5 m-0 p-0"  style={{ height: "100%", width: "50%"}}>
            <Link to="/flightsData" aria-label="Go to main menu" style={{ textDecoration: "none" }}>
              <LandingCard
                imagen={aeromexico}
                text="Vuelos"
                backColor="#01153a"
                ancho="60%"
              />
            </Link>
          </div>
          <div className="col-5 m-0 p-0"  style={{ height: "100%", width: "50%"}}>
          <Link to="/agenda" aria-label="Go to main menu" style={{ textDecoration: "none"}}>
              <LandingCard
                imagen={copa_ski}
                text="Agenda"
                backColor="#34646d"
                ancho="70%"
              />
            </Link>
          </div>
        </div>

        {/* second row */}
        <div className="row d-flex justify-content-evenly align-items-center m-0 p-0" style={{height: "39%"}}>
          <div className="col-5 m-0 p-0"  style={{ height: "100%", width: "50%"}}>
            <Link to="/rankings" aria-label="Go to rankings page" style={{ textDecoration: "none" }}>
              <LandingCard
                imagen={resultados}
                text="Resultados"
                backColor="#ec0068"
                ancho="50%"
              />
              </Link>
          </div>
          
          <div className="col-5 m-0 p-0" style={{ height: "100%", width: "50%"}}>
            <Link to="/experiences" aria-label="Go to main menu" style={{ textDecoration: "none"}}>
              <LandingCard
                imagen={experiencias}
                text="Actividades"
                backColor="#6ea7ed"
                ancho="70%"
              />
            </Link>
          </div>
        </div>

        {/* third row */}
        <div className="row d-flex justify-content-evenly align-items-center m-0 p-0" style={{height: "19%", minHeight: "70px"}}>
          <div className="col d-flex justify-content-center align-items-center m-0 px-2"  >
            <a
              href="https://wa.me/525656859418"  // <-- Replace with your real number
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contact via WhatsApp"
              style={{ textDecoration: 'none' }}
            >
              <LandingButtons
                imagen={whatsapp}
                backColor="#ffffff00"
                
              />
            </a>
          </div>

          <div className="col d-flex justify-content-center align-items-center m-0 px-2"  >
            <a
              href="https://www.instagram.com/copadeski/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Social media link"
              style={{ textDecoration: "none" }}
            >
              <LandingButtons
                imagen={instagram}
                backColor="#ffffff00"
                
              />
            </a>
          </div>

          <div className="col d-flex justify-content-center align-items-center m-0 px-2"  >
            <a
              href="https://www.epicpass.com/app.aspx"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download Epic App"
              style={{ textDecoration: "none" }}
            >
              <LandingButtons
                imagen={epic}
                backColor="#ffffff"
                
              />
            </a>
          </div>


          <div className="col d-flex justify-content-center align-items-center m-0 px-2" >
            <a
              // Updated from WhatsApp link to telephone protocol
              href="tel:+16049355555" 
              aria-label="Sos"
              style={{ textDecoration: "none" }}
            >
              <LandingButtons
                imagen={sos}
                backColor="#6e1d1d00"
                backColor2="#6e1d1d00"
                
              />
            </a>
          </div>

        </div>

      </div>
      <FooterLanding show_wa={false} />
    </div>
  );
}

